/**
 * @generated SignedSource<<81866f77f883efa6fdabd0bf4f53eee6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryOwnerChipNew_repository$data = {
  readonly owner: string;
  readonly " $fragmentType": "RepositoryOwnerChipNew_repository";
};
export type RepositoryOwnerChipNew_repository$key = {
  readonly " $data"?: RepositoryOwnerChipNew_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryOwnerChipNew_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryOwnerChipNew_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "19660b1a4111c9a38fbc28cfbff6479f";

export default node;
